import React, {Component} from 'react';
// Error Popup
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


/**
 * Props:
 * @prop {*} hideDuration - Defaults to 6000
 * @prop {*} handleSuccessClose
 * @prop {*} vertical - Defaults to 'bottom'
 * @prop {*} horizontal - Defaults to 'left'
 * @prop {*} message
 * @prop {*} open
 */


// Example handle close to use from parent, don't need event
/*
  handleClose = (event) => {
    this.setState({ open: false });
  };
*/
class SuccessPopup extends Component {
  render() {
    return (
        <Snackbar
        anchorOrigin={{
          vertical: this.props.vertical ? this.props.vertical : 'bottom',
          horizontal: this.props.horizontal ? this.props.horizontal : 'left',
        }}
        open={this.props.open}
        autoHideDuration={this.props.hideDuration ? this.props.hideDuration : 6000}
        onClose={this.props.handleSuccessClose}
        >
          <SnackbarContent
            style={{backgroundColor: '#43a047'}}
            message={<span id="client-snackbar" style={{display: 'flex', alignItems: 'center'}}><CheckCircleIcon style={{fontSize: 20, opacity: 0.9}} /> {this.props.message}</span>}
            action={<IconButton key="close" color="inherit" onClick={this.props.handleSuccessClose}><CloseIcon style={{fontSize: 20}} /></IconButton>}
          />
        </Snackbar>
    )
  }
}

export default SuccessPopup;